import React from 'react';
import styles from '../styles/ServicesGrid.module.css';
import { SERVICES } from '../data/services';

export default function ServicesGrid() {
  return (
    <section className={styles.section} id="services">
      <div className="container">

        {/* Header */}
        <div className={styles.header}>
          <span className={styles.label}>What We Offer</span>
          <h2 className={styles.title}>Our Services</h2>
          <p className={styles.subtitle}>
            From targeted email campaigns to high-converting phone outreach, we deliver
            the meetings that keep your pipeline full.
          </p>
        </div>

        {/* Cards grid */}
        <div className="row g-4">
          {SERVICES.map((svc, i) => (
            <div
              className={i < 3 ? 'col-lg-4 col-md-6' : 'col-lg-6 col-md-6'}
              key={svc.title}
            >
              <div className={styles.card}>
                <div className={styles.cardIcon} aria-hidden="true">{svc.icon}</div>
                {/* <span className={styles.badge}>{svc.label}</span> */}
                <h3 className={styles.cardTitle}>{svc.title}</h3>
                <p className={styles.cardDesc}>{svc.desc}</p>
                <a href={svc.href} className={styles.cardLink}>
                  Explore More <span className={styles.arrow}>→</span>
                </a>
              </div>
            </div>
          ))}
        </div>

      </div>
    </section>
  );
}
